import React, { Suspense, useCallback, useContext, useEffect, useState } from "react";
import { getEmployeeMissingListData } from "./Service/ReportService";
import { TostMsg } from "../../../App";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import moment from "moment";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Papa from "papaparse";
import { saveAs } from "file-saver";

function EmployeeMissingAttributes() {
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [Isloading, setIsloading] = useState(false);
  const toster = useContext(TostMsg);
  const [missingData, setMissingData] = useState([]);
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  const [employeeCreate, setEmployeeCreate] = useState(false);
  const [masterSystemAlertData, setMasterSystemAlertData] = useState([]);
  const defaultImage = "/images/placeholder_profile.png";
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [first, setFirst] = useState(0);
  const [filteredData, setFilteredData] = useState(missingData);
  const [missingHRShow, setMissingHRShow] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [selectMissingfEmp, setSelectMissingfEmp] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const selectedColumns = [
    "FullName",
    "CurrentDesignation",
    "CurrentDepartment",
    "HRName",
    "MissingEmpColumns",
    "MissingHRColumns"
  ];

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setMasterSystemAlertData(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        // setMasterSystemAlertData(msg?.Desc);
      }
    });
  }, []);

  const onSortChange = (e) => {
    setSortField(e.sortField);
    setSortOrder(e.sortOrder);

    const sortedData = [...filteredData].sort((a, b) => {
      let valueA = a[e.sortField];
      let valueB = b[e.sortField];

      if (typeof valueA === "string") valueA = valueA.toLowerCase();
      if (typeof valueB === "string") valueB = valueB.toLowerCase();

      if (valueA < valueB) return e.sortOrder;
      if (valueA > valueB) return -e.sortOrder;
      return 0;
    });

    setFilteredData(sortedData);
  };

  const onPageChange = (e) => {
    setFirst(e.first);
    setRowsPerPage(e.rows);

    const page = e.page; // PrimeReact gives page directly

    getEmployeeMissingList(page, e.rows, searchText);
  };

  const handleSearch = (e) => {
    const value = e.target.value;

    setSearchText(value);
    setFirst(0); // reset paginator

    getEmployeeMissingList(0, rowsPerPage, value);
  };

  useEffect(() => {
    getEmployeeMissingList(0, rowsPerPage, "");
    permissionAccouncementList();
    GetMasterSystemAlertList("Employee_Missing_Report", 1);
  }, []);

  const permissionAccouncementList = () => {
    userPermissions.map((UserPermission) => {
      if (UserPermission.PermissionName == "Employee.Create") {
        setEmployeeCreate(true);
      }
    });
  };

  async function getEmployeeMissingList(page = 0, size = rowsPerPage, search = searchText) {
    setIsloading(true);

    const params = {
      Search: search || "",
      PageNumber: page + 1,   // backend usually 1-based
      PageSize: size
    };

    try {
      const response = await getEmployeeMissingListData(params);

      setMissingData(response?.Data || []);
      setTotalRecords(response?.Data[0]?.totalEmpCount || 0);  // MUST come from API
      setIsloading(false);
    } catch (error) {
      toster.current.error(ERROR_LIST.DefaultError);
      setIsloading(false);
    }
  }

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage; // Set the fallback image on error
  }, []);

  const styleFullName = (rowData) => {
    return (
      <Link to={`/Profile/${rowData.GUID}`}>
        <div className="d-flex align-items-center">
          <img
            src={rowData?.ProfileImage || defaultImage}
            onError={handleImageError}
            className="rounded-lg me-2"
            width="24"
            alt=""
          />{" "}
          <span className="w-space-no">
            {rowData?.FullName} ({rowData?.EmploymentId})
          </span>
        </div>
      </Link>
    );
  };

  function exportToCSV() {
    if (!selectMissingfEmp || selectMissingfEmp.length === 0) {
      toster.current.warn("Please select at least one employee");
      return;
    }
    const filteredData = selectMissingfEmp.map((row) => {
      return selectedColumns.reduce((acc, col) => {
        acc[col] = row?.[col] ?? "";
        return acc;
      }, {});
    });
    const csv = Papa.unparse(filteredData);
    const blob = new Blob([csv], {
      type: "text/csv;charset=utf-8;"
    });
    saveAs(blob, "MissingEmployeeReport.csv");
  }

  return (
    <div>
      <div className="container-fluid position-relative">
        <div className="row team-directories g-3">
          <div className="col-xl-12">
            <div className="form-head d-flex flex-wrap align-items-center">
              <div className="me-auto">
                <h2 className="font-w600 mb-0">Incomplete Profile Summary</h2>
                {/* <p>{masterSystemAlertData}</p> */}
                <p>All employees with incomplete profile information, highlighting missing required attributes.</p>
              </div>
              <div className="rightside-tabs">
                <Link to="/Reports">
                  <button className="back-newticket w-auto float-right">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-arrow-left-short"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                      />
                    </svg>{" "}
                    Back
                  </button>
                </Link>
              </div>

            </div>
          </div>
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body">
                <div className="form-head  mb-3">

                  <div className="d-flex align-items-center rightside-tabs col-lg-6">
                    {/* <div
                                            className="me-2 select-futurepost-article"
                                            title="Ex-Employee View"
                                        >
                                            <label style={{ cursor: "pointer" }}>Ex-Employee</label>
                                            <div className="ml-auto d-flex">
                                                
                                            </div>
                  </div> */}

                    {/* <div className="org-cate me-2">
                                            
                                        </div> */}
                    <div className="d-flex align-items-center me-2">
                      <input
                        type="checkbox"
                        checked={missingHRShow}
                        onChange={(e) => setMissingHRShow(e.target.checked)}
                      />
                      <label style={{ marginLeft: "3px", marginBottom: "0px", fontSize: "12px" }}>
                        Missing HR Attributes
                      </label>
                    </div>
                    <input
                      type="text"
                      className="form-control me-2 col-lg-5"
                      onChange={handleSearch}
                      placeholder="Search"
                    />

                    <div className="org-cate me-2">
                      <button
                        className="export-btn"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Export"
                        onClick={() => exportToCSV()}
                      >
                        <img
                          src="/images/excels.png"
                          alt="export"
                          style={{ width: "23px" }}
                        />
                      </button></div>
                    
                  </div >
                </div >
    <div className="table-responsive">
      <div className="table table-bordered Employeelist ">
        <DataTable

          value={missingData}
          lazy
          paginator
          first={first}
          rows={rowsPerPage}
          totalRecords={totalRecords}
          onPage={onPageChange}
          loading={Isloading}
          dataKey="Id"
          selection={selectMissingfEmp}
          onSelectionChange={(e) => setSelectMissingfEmp(e.value)}
          selectionPageOnly={false}
          rowsPerPageOptions={[5, 10, 25, 50]}
          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="{first} to {last} of {totalRecords}"
          tableStyle={{ minWidth: "50rem" }}
        >
          <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
          <Column field="FullName" body={styleFullName} header="Name" />
          <Column field="CurrentDesignation" header="Designation" />
          <Column field="CurrentDepartment" header="Department" />
          <Column field="HRName" header="HR" />
          <Column
            field="MissingEmpColumns"
            header="Employee Attribute"
          />
          {missingHRShow && (
            <Column field="MissingHRColumns" header="HR Attribute" />
          )}
          {/* <Column field="SeniorEmails" header="SeniorEmails" /> */}
          {/* <Column field="HREmail" header="HR Email" /> */}
        </DataTable>
      </div>
    </div>
              </div >
            </div >
          </div >
        </div >
      </div >
  {
    Isloading?(
          <Suspense>
    <ComponentLoader />
          </Suspense >
        ) : ("")
}
    </div >
  );
}

export default EmployeeMissingAttributes;
